import React, { useState } from 'react';
import { ContainerSection } from '../../../../../../components/NovoSistema/ContainerSection';
import InputCheckBox from '../../../../../../components/NovoSistema/InputCheckBox';
import InputDate from '../../../../../../components/NovoSistema/InputDate';
import InputText from '../../../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../../../components/NovoSistema/SelectAndOptions';
import ButtonsGeneric from '../../../../../../components/NovoSistema/ButtonsGeneric';
import { WrapperInputsNewSystem } from '../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function ContasAReceberAdd({ setOption }) {
  const [showOrHideImpostosRetidos, setShowOrHideImpostosRetidos] = useState(false);
  const [showOrHideTornarPeriodico, setShowOrHideTornarPeriodico] = useState(false);
  const [showOrHideOutrosDados, setShowOrHideOutrosDados] = useState(false);
  const [showOrHideAttachments, setShowOrHideAttachments] = useState(false);

  return (
    <div>
      <ContainerSection>
        <h3>Principal</h3>
        <div>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="Docto Fiscal / Tipo"
              id="DoctoFiscal"
              optionsArray={['', '1 - NF - Nota Fiscal', '1B - NFA - Nota Fiscal Avulsa']}
              widthPercentage="20%"
            />
            <InputText title="*Nro Documento" id="NroDocumento" widthPercentage="20%" />
            <InputDate title="*Data de Emissão" id="DataEmissao" widthPercentage="20%" />
            <InputText title="Origem" id="Origem" widthPercentage="20%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <InputText title="*Parceiro de Negócios" id="ParceiroDeNegocios" widthPercentage="60%" />
            <InputText title="*Valor Líquido" id="ValorLiquido" widthPercentage="30%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="*Conta Bancária"
              id="ContaBancaria"
              optionsArray={['', 'Novo...', '999 | 9999 | 9999-9 | Caixinha']}
              widthPercentage="30%"
            />
            <SelectAndOptions
              title="*Forma"
              id="Forma"
              optionsArray={['', 'Novo...', 'Dinheiro', 'Cheque']}
              widthPercentage="30%"
            />
            <SelectAndOptions
              title="*CNAB | Carteira"
              id="CNABCarteira"
              optionsArray={['', '#']}
              widthPercentage="30%"
            />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <InputText title="Observação Boleto" id="ObservacaoBoleto" widthPercentage="60%" />
            <SelectAndOptions
              title="Categoria"
              id="CNABCarteira"
              optionsArray={[
                '',
                'Novo...',
                'Ajuste de Caixa - Receita',
                'Aplicações Financeiras',
                'Empréstimo',
                'Outras Receitas',
                'Venda de Ativo Imobilizado',
                'Vendas',
              ]}
              widthPercentage="30%"
            />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <InputText title="Histórico" id="ObservacaoBoleto" widthPercentage="90%" />
          </WrapperInputsNewSystem>
        </div>
      </ContainerSection>
      <ContainerSection>
        <h3 onClick={() => setShowOrHideImpostosRetidos((e) => !e)}>
          {showOrHideImpostosRetidos ? '- ' : '+ '}Impostos Retidos
        </h3>
        {showOrHideImpostosRetidos && (
          <div>
            <WrapperInputsNewSystem>
              <InputText title="Valor PIS" id="ValorPIS" widthPercentage="30%" />
              <InputText title="Valor Confins" id="ValorConfins" widthPercentage="30%" />
              <InputText title="Valor CLSS" id="ValorCLSS" widthPercentage="30%" />
            </WrapperInputsNewSystem>
            <WrapperInputsNewSystem>
              <InputText title="Valor ISS" id="ValorISS" widthPercentage="30%" />
              <InputText title="Valor IR" id="ValorIR" widthPercentage="30%" />
              <InputText title="Valor INSS" id="ValorINSS" widthPercentage="30%" />
            </WrapperInputsNewSystem>

            <WrapperInputsNewSystem>
              <InputCheckBox title="Descontar IRFF, ISS e INSS na 1º Parcela" id="Descontar" />
              <InputCheckBox title="Destacar Impostos Retidos no Boleto" id="Destacar" />
            </WrapperInputsNewSystem>
          </div>
        )}
      </ContainerSection>
      <ContainerSection>
        <h3>Cálculos dos vencimentos</h3>
        <div>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="Condição de Pagamento"
              id="CondicaoPagamento"
              optionsArray={['', 'Novo...', 'à vista', '30 dias', '30/60 dias', '30/60/90 dias']}
              widthPercentage="40%"
            />
            <InputText title="Parcelas" id="Parcelas" widthPercentage="20%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="Descontos"
              id="Descontos"
              optionsArray={['', 'Descontos %', 'Descontos R$']}
              widthPercentage="15%"
            />
            <InputText title="Valor Descontos" id="ValorDescontos" widthPercentage="15%" />
            <InputText title="Dias Antes" id="DiasAntes" widthPercentage="15%" />
            <SelectAndOptions
              title="Multa"
              id="Multa"
              optionsArray={['', 'Multa %', 'Multa R$']}
              widthPercentage="15%"
            />
            <InputText title="Valor Multa" id="ValorMulta" widthPercentage="15%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="Juros"
              id="Juros"
              optionsArray={['', 'Juros %', 'Juros R$']}
              widthPercentage="15%"
            />
            <InputText title="Valor Juros" id="ValorJuros" widthPercentage="15%" />
            <InputText title="Dias Antes" id="DiasAntes" widthPercentage="15%" />
            <SelectAndOptions
              title="Acréscimos"
              id="Acrescimos"
              optionsArray={['', 'Acréscimos %', 'Acréscimos R$']}
              widthPercentage="15%"
            />
            <InputText title="Valor Acréscimos" id="ValorAcrescimos" widthPercentage="15%" />
          </WrapperInputsNewSystem>
          <ButtonsGeneric>
            <button className="success">Gerar Parcelas</button>
          </ButtonsGeneric>
        </div>
      </ContainerSection>
      <ContainerSection>
        <h3 onClick={() => setShowOrHideTornarPeriodico((e) => !e)}>
          {showOrHideTornarPeriodico ? '- ' : '+ '}Tornar Periódico
        </h3>
        {showOrHideTornarPeriodico && (
          <div>
            <WrapperInputsNewSystem>
              <InputText title="Repetir a cada mês(es)" id="Parcelas" widthPercentage="30%" />
              <InputCheckBox title="Até" id="opc1" />
              <InputText title="Ocorrências" id="Ocorrencias" widthPercentage="20%" />
              <button>Cancelar</button>
            </WrapperInputsNewSystem>
          </div>
        )}
      </ContainerSection>
      <ContainerSection>
        <h3 onClick={() => setShowOrHideOutrosDados((e) => !e)}>{showOrHideOutrosDados ? '- ' : '+ '}Outros dados</h3>
        {showOrHideOutrosDados && (
          <div>
            <WrapperInputsNewSystem>
              <InputText title="Descrição" id="Descricao" widthPercentage="50%" />
              <InputText title="Vendedor" id="Vendedor" widthPercentage="20%" />
              <InputText title="Matrícula" id="Matricula" widthPercentage="20%" />
            </WrapperInputsNewSystem>
          </div>
        )}
      </ContainerSection>
      <ContainerSection>
        <h3 onClick={() => setShowOrHideAttachments((e) => !e)}>{showOrHideAttachments ? '- ' : '+ '}Anexos</h3>
        {showOrHideAttachments && (
          <WrapperInputsNewSystem>
            <input type="file" name="attachments" id="attachments" />
          </WrapperInputsNewSystem>
        )}
      </ContainerSection>
      <ContainerSection>
        <h3>Boletos/Remessas</h3>
      </ContainerSection>
      <ButtonsGeneric>
        <button className="success">Salvar</button>
        <button className="error" onClick={() => setOption('search')}>
          Retornar
        </button>
      </ButtonsGeneric>
      <span> {' * '} Campo de preenchimento Obrigatório</span>
    </div>
  );
}
